import { Component, OnInit, Input } from "@angular/core";
import { CTAButtonLayout } from "../cta-button-layout";
import { CTAButtonLayoutPromoDiscountsContext } from "./cta-button-layout-promo-discounts.models";

@Component({
    selector: "dodo-cta-button-layout-promo-discounts",
    templateUrl: "./cta-button-layout-promo-discounts.component.html",
    styleUrls: ["./cta-button-layout-promo-discounts.component.scss"],
    standalone: false
})
export class CtaButtonLayoutPromoDiscountsComponent extends CTAButtonLayout
	implements OnInit {
	@Input() promoName: string;
	@Input() promoDescription: string;
	@Input() iconImage: string;
	@Input() marketing: {
		text: string;
		textDecoration: string;
	};

	@Input() set context(ctx: CTAButtonLayoutPromoDiscountsContext) {
		if (ctx) {
			this.promoName = this.promoName || ctx.promoName;
			this.iconImage = this.iconImage || ctx.iconImage;
			this.promoDescription =
				this.promoDescription || ctx.promoDescription;
		}
	}

	set layoutContext(ctx: CTAButtonLayoutPromoDiscountsContext) {
		if (ctx) {
			this.promoName = this.promoName || ctx.promoName;
			this.iconImage = this.iconImage || ctx.iconImage;
			this.promoDescription =
				this.promoDescription || ctx.promoDescription;
		}
	}

	constructor() {
		super();
	}

	ngOnInit() {}
}
